import Component from './component.js'

export default Component
